<template>
   <div class="mod_linkpanel">
        <div class="linkitems">
            <div class="linkitem number-1" onclick="document.querySelector('div[id^=\'userlike-\'] iframe')?.contentWindow.document.querySelector('button').click()">
                <div class="imgcont"><img src="//agila.de/images/sonstige/AGILA-Icon-Set-Erweiterung-Chat.png" alt="Chat" /></div>
                        Chat</div>
            <div class="linkitem number-5 hidden-desktop hidden-tablet" v-if="lead.productSet != 11 && lead.productSet != 12 && lead.productSet != 3">
                <a href="tel:+49 511 93680377" v-if="country != 'Österreich'"><div class="imgcont"><img src="//agila.de/images/sonstige/AGILA-Icon-Telefon-blau-2021-04-14-RZ_original.png" alt="Telefon" /></div>
                        Telefon</a>
                <a href="tel:00800-71280-345" v-if="country == 'Österreich'"><div class="imgcont"><img src="//agila.de/images/sonstige/AGILA-Icon-Telefon-blau-2021-04-14-RZ_original.png" alt="Telefon" /></div>
                        Telefon</a></div>
            <div class="linkitem number-5 hidden-desktop hidden-tablet">
                <a v-on:click="cc()"><div class="imgcont"><img src="//agila.de/templates/agila/images/agila-icon-cookie-02.svg" alt="Cookies" /></div>
                        Cookies</a></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        registry: {
            type: Object,
            default() {
                return {}
        }},
        lead: {
            type: Object,
            default() {
                return {}
        }}
    },
    data: () => ({
        country: ''
    }),
    watch: {
        lead: {
            immediate: true,
            deep:true,
            handler (to) {
                this.country = to.country
            }
        }
    },

    methods: {
        cc() {
          window.consentManager.open();
        }
	}
}
</script>
<style scoped>
.mod_linkpanel .linkitem {
  font-family: var(--font-medium) !important;
}
@media (min-width: 769px) {
	.mod_linkpanel {
        display:none;
    }
}
.imgcont{
    cursor:pointer;
    margin-bottom: 5px;
}
</style>
